namespace Areas.Inspections {
    import Data = DevExpress.data;
    "use strict";

    //
    //CRUD functions
    //

    let roomSelectedItems: string[];
    let roomSelectedItemsString: string;

    export let inspectionTypeLk: string;

    export function onContentReady() {


        if (elementIdExists("InspectionsForm")) {
            const form = $("#InspectionsForm").dxForm("instance");
            const data = form.option("formData");

            inspectionTypeLk = data.InspectionTypeLk;
            const subTypeEditor = form.getEditor("InspectionSubTypeLk") as DevExpress.ui.dxLookup;
            subTypeEditor.getDataSource().reload();
            subTypeEditor.repaint();
        }
    }

    export function getInspectionType() {
        return inspectionTypeLk;
    }

    var formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {

        formCrudOps = new FormCrudOperations("Inspections",
            (newData: any) => {
                newData.InspectionGroupString = roomSelectedItemsString;
            });

    }

    export function processSingleReturn() {
        const verifyVoid = window.confirm("Are you sure you would like to RETURN this record to the Requestor?");

        if (verifyVoid) {
            const form = $("#InspectionsForm").dxForm("instance");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");

            if (keyId != null && projectId != null) {
                sendRequest(`/Inspections/Edit/ReturnToRequestor/${keyId}/${projectId}/`, "", "PUT");
            }
        }
    }

    export function updateWriteUp(e: any) {
        const form = $("#InspectionWriteUpForm").dxForm("instance");
        const newData: any = form.option("formData");
        const keyId: any = form.option("KeyId");
        const projectId = form.option("ProjectId");

        if (keyId != null && projectId != null) {
            sendRequest(`/Inspections/WriteUp/Put/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
        }
    }

    export function writeUpRequestApproved(e: any) {
        const form = $("#InspectionWriteUpForm").dxForm("instance");
        const newData: any = form.option("formData");
        const keyId: any = form.option("KeyId");
        const projectId = form.option("ProjectId");

        if (keyId != null && projectId != null) {
            sendRequest(`/Inspections/WriteUp/Approved/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
        }
    }

    export function writeUpRequestRejected(e: any) {
        const form = $("#InspectionWriteUpForm").dxForm("instance");

        const newData: any = form.option("formData");
     

        const keyId: any = form.option("KeyId");
        const projectId = form.option("ProjectId");

        if (keyId != null && projectId != null) {
            sendRequest(`/Inspections/WriteUp/Rejected/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
        }
    }

    export function updateDeputy(e: any) {
        const form = $("#InspectionDeputyForm").dxForm("instance");

        const newData: any = form.option("formData");
     

        const keyId: any = form.option("KeyId");
        const projectId = form.option("ProjectId");

        if (keyId != null && projectId != null) {
            sendRequest(`/Inspections/Deputy/Put/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
        }
    }

    export function submitDeputy(e: any) {
        const form = $("#InspectionDeputyForm").dxForm("instance");

        const newData: any = form.option("formData");
     

        const keyId: any = form.option("KeyId");
        const projectId = form.option("ProjectId");

        if (keyId != null && projectId != null) {
            sendRequest(`/Inspections/Deputy/SubmitDeputyWriteUp/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
        }
    }

    export function submitInspection(e: any) {
        const form = $("#InspectionsForm").dxForm("instance");

        const newData: any = form.option("formData");
     
        newData.InspectionGroupString = roomSelectedItemsString;

        const result: any = form.validate();
            if (result.isValid) {
                const keyId: any = form.option("KeyId");
                const projectId = form.option("ProjectId");
        
                if (keyId != null && projectId != null) {
                    sendRequest(`/Inspections/Edit/Submit/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
                }
        }
    }

    export function updateAssign(e: any) {
        const form = $("#InspectionsForm").dxForm("instance");
        const assignForm = $("#InspectionAssignForm").dxForm("instance");

        const newData: any = form.option("formData");
        const assignData = assignForm.option("formData");

        newData.InspectorLk = assignData.InspectorLk;
        newData.PlannedInspectionDate = assignData.PlannedInspectionDate;
        newData.IsDeputyInspectorAssigned = assignData.IsDeputyInspectorAssigned;
        newData.InspectionGroupString = roomSelectedItemsString;

        const result: any = form.validate();
        const result2: any = assignForm.validate();

        if (result.isValid && result2.isValid) {
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");

            if (keyId != null && projectId != null) {
                sendRequest(`/Inspections/Assign/Put/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
            }
        }
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }


    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function deleteRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const form = $("#InspectionsForm").dxForm("instance");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");
            const iComments = form.option("InspectorsComments");

            if (keyId != null && projectId != null) {
                sendRequest(`/Inspections/Edit/Delete/${keyId}/${projectId}/`, "", "DELETE");
            }
        }
    }

    export function deleteRecordFromWriteUp() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const form = $("#InspectionWriteUpForm").dxForm("instance");
            const newData: any = form.option("formData");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");
           /* newData.StatusLk = "Void";*/  /*PutVoid sets status to void*/

           if (keyId != null && projectId != null) {
               sendRequest(`/Inspections/WriteUp/PutVoid/${keyId}/${projectId}/`, JSON.stringify(newData), "PUT");
           }
        }
    }

 
    //multi-room select located here because variable roomSelectedItemsString needed for update

    export function AreaRoomChanged(data) {

        roomSelectedItems = $.map(roomSelectedItems, function(item) { return item });

        var listForm: DevExpress.ui.dxForm = $('#MultiSelectGroupForm').dxForm('instance');
        var listFormData: any = listForm.option('formData');

        var listControl: any = $('#roomListControl').dxList('instance');

        if (listControl.option("selectedItemKeys").length > 0) {
            roomSelectedItemsString = null;
            for (var i = 0; i < listControl.option("selectedItemKeys").length; i++) {
                if (roomSelectedItemsString === null) {
                    roomSelectedItemsString = listControl.option("selectedItemKeys")[i].InspectionGroupId;

                } else {
                    roomSelectedItemsString = roomSelectedItemsString +
                        "|" +
                        listControl.option("selectedItemKeys")[i].InspectionGroupId;
                }

                listFormData.InspectionGroupString = roomSelectedItemsString;
            }
        } else listFormData.InspectionGroupString = null;

    }


    export function OnContentReadyMarkListItems(listControl) {

        listControl.component.paginate = false;

        window.setTimeout(function () {
            var items = listControl.component.option("items");

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.IsChecked) {
                    listControl.component.selectItem(i);

                }
            }

        }, 200);
    }


    export function listItemTemplate(itemdata, itemIndex, itemElement) {

        itemElement.text(`${itemdata.Description}`);

    }


}
